import { headerSysAdmin } from "src/services/api/headers";
import storage from "src/services/storage";
import { TOKEN } from "src/helpers/constant";

const apiUrl = process.env.VUE_APP_API_END_POINT;

let menuPermissionCache = null;
let menuPermissionPromise = null;

export function clearMenuPermissionCache() {
  menuPermissionCache = null;
  menuPermissionPromise = null;
}

export async function loadCurrentMenuPermissions(force = false) {
  if (!storage.get(TOKEN)) {
    clearMenuPermissionCache();
    return null;
  }

  if (menuPermissionCache && !force) {
    return menuPermissionCache;
  }

  if (menuPermissionPromise && !force) {
    return menuPermissionPromise;
  }

  menuPermissionPromise = (async () => {
    const response = await fetch(`${apiUrl}/admins-system/current-menu-permissions`, {
      withCredentials: true,
      headers: headerSysAdmin(),
      method: "GET",
    });

    const json = await response.json();

    if (!response.ok || !json?.data) {
      throw new Error(json?.message || "Failed to load current menu permissions.");
    }

    menuPermissionCache = json.data;
    return menuPermissionCache;
  })();

  try {
    return await menuPermissionPromise;
  } finally {
    menuPermissionPromise = null;
  }
}
